var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.5C5.65625 5.5 6 5.84375 6 6.25V9.46875C7.21875 7.375 9.5 6.03125 12 6.03125C15.8438 6.03125 19 9.15625 19 13C19 16.875 15.8438 20 12 20C10.3438 20 8.75 19.4375 7.5 18.4062C7.1875 18.125 7.15625 17.6562 7.40625 17.3438C7.6875 17.0312 8.15625 16.9688 8.46875 17.25C9.4375 18.0625 10.6875 18.5 12 18.5C15.0312 18.5 17.5 16.0625 17.5 13C17.5 9.96875 15.0312 7.5 12 7.5C9.90625 7.5 8.03125 8.71875 7.09375 10.5H10.25C10.6562 10.5 11 10.8438 11 11.25C11 11.6875 10.6562 12 10.25 12H5.25C4.8125 12 4.5 11.6875 4.5 11.25V6.25C4.5 5.84375 4.8125 5.5 5.25 5.5Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/RotateLeft.e428521a81b10fc40fc61ade2aff9783.svg";
export { ForwardRef as ReactComponent };